import React, { Fragment, useEffect } from "react";

import { matchPath, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useIntl } from "react-intl";
import { useLocation } from "react-router";
import { usePageData, PageButtonLink } from "src/_metronic/layout/core";
import RequiredRole from "src/app/components/auth/RequiredRole";
import {
    checkPathRequirement,
    getRequiredRoleByPath,
} from "src/app/routing/RouteRequirementHandler";
import { useAuth } from "src/app/utils/useAuth";
import OnlineGridAll from "./OnlineGridAll";
import OnlineGridSell from "./OnlineGridSell";
import OnlineGridNetwork from "./OnlineGridNetwork";

const OnlineManagementWrapper: React.FC = () => {
    const location = useLocation();
    const { formatMessage } = useIntl();
    const { setPageToolbarLinks } = usePageData();

    const { currentUser } = useAuth();

    const basePath = "/content/online/";

    const SiteSectionLinks: Array<PageButtonLink & { children: React.FC }> = [
        {
            path: "all",
            title: formatMessage({ id: "online.manage.all.link" }),
            isActive: false,
            isSeparator: false,
            children: OnlineGridAll,
        },
        {
            path: "sell",
            title: formatMessage({ id: "online.manage.sell.link" }),
            isActive: false,
            isSeparator: false,
            children: OnlineGridSell,
        },
        {
            path: "network",
            title: formatMessage({ id: "online.manage.network.link" }),
            isActive: false,
            isSeparator: false,
            children: OnlineGridNetwork,
        },
    ];

    useEffect(() => {
        setPageToolbarLinks(
            SiteSectionLinks.map((link) => {
                if (checkPathRequirement(basePath + link.path, currentUser?.role)) {
                    link.path = basePath + link.path;
                    link.isActive = !!matchPath(link.path, location.pathname);
                    return link;
                }
                link = {
                    path: "",
                    title: "",
                    isActive: false,
                    isSeparator: false,
                    children: () => <></>,
                };

                return link;
            })
        );
    }, [location]);

    return (
        <Routes>
            <Route element={<Outlet />}>
                {SiteSectionLinks.map(({ path, children }, i) => {
                    const roles = getRequiredRoleByPath(basePath + path);
                    return (
                        <Fragment key={i}>
                            <Route element={<RequiredRole allowedRoles={roles} />}>
                                <Route
                                    path={path}
                                    element={<>{React.createElement(children, {})}</>}
                                />
                            </Route>
                        </Fragment>
                    );
                })}
                <Route index element={<Navigate to="all" />} />
            </Route>
        </Routes>
    );
};

export default OnlineManagementWrapper;
